/**
 * Texts for User Training page - Norwegian
 */
export const userTrainingPageText = {
    title: 'Brukeropplæring - CamAPS FX',
    titleMeta: 'Omfattende opplæringsressurser for CamAPS FX-brukere',
    descriptionMeta: 'Tilgang til komplette opplæringsmateriell, videoveiledninger, brukerveiledninger og webinarer for å få mest mulig ut av CamAPS FX.',
    keywords:
        'camaps fx brukeropplæring, camaps opplæring, diabetesopplæring, insulinpumpe opplæring, brukerveiledning, videoveiledninger',
    localeMeta: 'nb_no',

    mainHeader: 'Brukeropplæring',
    mainSubHeader: 'Fullfør den grunnleggende opplæringen i appen før du bruker CamAPS FX-appen.',

    gettingStartedHeader: 'Komme i gang',
    step1Title: '<strong>Trinn 1:</strong><br/>Last ned appen',
    step2Title: '<strong>Trinn 2:</strong><br/>Opprett en konto',
    step3Title: '<strong>Trinn 3:</strong><br/>Begynn den grunnleggende opplæringen i appen',
    step4Title: '<strong>Trinn 4:</strong><br/>Par med din valgte pumpe og CGM (med godkjenning fra helseteamet ditt) eller utforsk appen med <strong>virtuell modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Trenger du hjelp med å installere appen?',
    supportSectionText: 'Besøk vår supportdel for veiledning',
    supportButtonText: 'STØTTE',
    findOutMoreButtonText: 'LES MER',

    additionalResourcesTitle: 'Ytterligere ressurser',
    additionalResourcesSubtitle: 'Lær gjennom trinn-for-trinn-bilder eller se ekspertledede økter om bruk av appen.',
    
    animationsTitle: 'Animasjoner',
    animationsDescription: 'Dana insulinpumpen er for øyeblikket kun tilgjengelig kommersielt med CamAPS FX i Storbritannia. Alle ressurser relatert til Dana er derfor kun tilgjengelig på engelsk.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinarer',
    webinarsDescription: 'Disse nettseminarene er nyttige for personer med diabetes type 1, familiene og pleierne deres, samt lærere, skolepersonell og helsepersonell. De er tilgjengelige på engelsk. Klikk på et nettseminar for å finne ut mer.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Faktaark',
    factsheetsDescription: 'Dana insulinpumpen er for øyeblikket kun tilgjengelig kommersielt med CamAPS FX i Storbritannia. Alle ressurser relatert til Dana er derfor kun tilgjengelig på engelsk.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Opplæring i appen',
    inAppTrainingText: 'Start med den grunnleggende opplæringen som er innebygd i CamAPS FX-appen. Denne interaktive opplæringen veileder deg gjennom alle viktige funksjoner du trenger å kjenne til.<br/><br/><strong>Tilgang:</strong> Last ned CamAPS FX-appen og opprett en konto for å begynne opplæringen i appen.',

    gettingStartedText: '<strong>Trinn 1:</strong> Last ned CamAPS FX-appen fra enhetens appbutikk<br/><strong>Trinn 2:</strong> Opprett kontoen din<br/><strong>Trinn 3:</strong> Fullfør opplæringsmodulene i appen<br/><strong>Trinn 4:</strong> Koble til insulinpumpen og CGM<br/><strong>Trinn 5:</strong> Start din CamAPS FX-reise',

    trainingResourcesHeader: 'Ytterligere opplæringsressurser',
    videoTutorialsText: 'Videoveiledninger',
    videoTutorialsDesc: 'Se trinn-for-trinn-videoveiledninger som dekker installasjon, daglig bruk og feilsøking.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Brukerveiledninger og dokumentasjon',
    userGuidesDesc: 'Last ned omfattende PDF-veiledninger og hurtigreferansemateriell.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live-webinarer',
    webinarsDesc: 'Delta på ekspertledede opplæringsøkter og spørsmål og svar-muligheter.',

    needHelpHeader: 'Trenger du hjelp?',
    needHelpTextStart: 'Hvis du trenger hjelp eller har spørsmål, besøk vår',
    supportLinkText: 'Support',
    needHelpTextEnd: 'side for ytterligere hjelp og kontaktinformasjon.'
};

